var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "comment-block" }, [
    _c("hr", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isReply,
          expression: "isReply",
        },
      ],
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row", class: { "inital-comment": !_vm.isReply } },
      [
        _c("div", { staticClass: "col-12 col-sm-auto" }, [
          _c(
            "div",
            {
              staticClass: "avatar mx-auto",
              class: { "avatar-sm d-none d-sm-block": _vm.isReply },
            },
            [
              _vm.comment.commentator.avatar_thumbnail
                ? _c("img", {
                    attrs: {
                      src: _vm.comment.commentator.avatar_thumbnail,
                      alt: "",
                    },
                  })
                : _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "100%",
                        height: "100%",
                        viewBox: "0 0 192 192",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          fill: "#737270",
                          d: "M176.2,148.775a96.023,96.023,0,0,1-160.443-.052c6.809-13.478,22.857-22.22,46.68-26.163a53.485,53.485,0,0,0,67.35.1C153.527,126.647,169.419,135.34,176.2,148.775Z",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          fill: "#737270",
                          "fill-rule": "evenodd",
                          cx: "96",
                          cy: "81.234",
                          r: "47.375",
                        },
                      }),
                    ]
                  ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col mt-2" }, [
          _c("div", { staticClass: "comment-headline" }, [
            _vm._v(
              "\n                #" +
                _vm._s(_vm.identifier) +
                " \n                "
            ),
            _c("strong", [
              _vm._v(_vm._s(_vm.comment.commentator.display_name)),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "badge badge-info",
                staticStyle: { "vertical-align": "text-top" },
              },
              [_vm._v(_vm._s(_vm.comment.badge))]
            ),
            _vm._v(" "),
            _c("small", { staticClass: "comment-date" }, [
              _vm._v(
                "am " + _vm._s(_vm._f("formatDate")(_vm.comment.created_at))
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "pt-2", staticStyle: { "white-space": "pre-wrap" } },
            [_vm._v(_vm._s(_vm.comment.comment))]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      !_vm.isReply
        ? _c("div", { staticClass: "col-auto comment-indent d-none d-sm-flex" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-wrap align-items-center mb-3" },
            [
              _vm.comment.comments.length > 0 && !_vm.isReply
                ? [
                    _vm.repliesVisible === false
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-link collapse-toggle collapsed",
                            on: { click: _vm.toggleReplies },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.__("Show all replies")) +
                                " (" +
                                _vm._s(_vm.comment.comments.length) +
                                ")\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.repliesVisible === true
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-link collapse-toggle",
                            on: { click: _vm.toggleReplies },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.__("Hide replies")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isReply
                ? _c("span", { staticClass: "small text-muted" }, [
                    _vm._v("Antwort auf #" + _vm._s(_vm.replyIdentifier)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.canReply
                ? _c(
                    "button",
                    {
                      staticClass: "ml-auto btn btn-sm btn-secondary",
                      on: { click: _vm.showReplyArea },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.__("Reply Comment")))])]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.canReply
            ? _c(
                "form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.replyAreaOpen,
                      expression: "replyAreaOpen",
                    },
                  ],
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    },
                    keydown: _vm.reset,
                  },
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.comment,
                          expression: "form.comment",
                        },
                      ],
                      ref: "commentArea",
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.form.errors.has("comment") },
                      attrs: {
                        placeholder: _vm.__("Your reply"),
                        id: "comment",
                        name: "comment",
                      },
                      domProps: { value: _vm.form.comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "comment", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.form.errors.has("comment")
                      ? _c("div", {
                          staticClass: "invalid-feedback",
                          domProps: {
                            textContent: _vm._s(
                              _vm.form.errors.first("comment")
                            ),
                          },
                        })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group d-flex justify-content-end" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link",
                          attrs: { type: "cancel" },
                          on: { click: _vm.hideReplyArea },
                        },
                        [_vm._v(_vm._s(_vm.__("Cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "submit",
                            disabled: _vm.form.errors.any(),
                          },
                        },
                        [_vm._v(_vm._s(_vm.__("Reply")))]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.comment.comments, function (nestedComment, key) {
            return _c("discussion-item", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.repliesVisible || _vm.isReply,
                  expression: "repliesVisible || isReply",
                },
              ],
              key: `reply_${nestedComment.id}`,
              attrs: {
                "main-level": _vm.mainLevel,
                "second-level": key + 1,
                "can-reply": _vm.canReply,
                "parent-comment": _vm.comment,
                "parent-id": _vm.parentId,
                "training-id": _vm.trainingId,
                "is-reply": true,
                "initial-comment": nestedComment,
              },
            })
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("hr", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isReply,
          expression: "!isReply",
        },
      ],
      staticClass: "mt-0",
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }